module.exports = __webpack_public_path__ + "img/bingo-canto-silabas-inversas.e1a362df.png";